var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.img !== null)?_c('div',{staticClass:"flex justify-content-center"},[_c('div',{staticClass:"id-file",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.preventDefault();return _vm.openImageModal(_vm.img)}}},[_c('img',{staticClass:"id-file img-fluid",attrs:{"alt":"id file","src":_vm.img}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }